export enum AddressingLineLookupStatus {
  Invalid = 'invalid',
  Registered = 'registered',
  Unavailable = 'unavailable',
  Unmatched = 'unmatched',
  Unregistered = 'unregistered',
}
